import { useEffect, useState } from 'react';
import { getScreenerSectors } from '../../api/screener.api';
import { SectorCriteriaItem } from '../../Components/Screener/Criteria/SectorCriteria/SectorCriteria';
import { toSentenceCase } from '../../utils/utils';

export interface UseScreenerSectorsResult {
  sectors: SectorCriteriaItem[];
  isLoaded: boolean;
}

const useScreenerSectors = (token: string): UseScreenerSectorsResult => {
  const [sectors, setSectors] = useState<SectorCriteriaItem[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    getScreenerSectors(token)
      .then((items) => {
        const sorted = items
          .map((item) => ({
            label: toSentenceCase(item.label),
            value: String(item.id),
            selected: true,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setSectors(sorted);
      })
      .catch((err) => {
        console.error('Failed to fetch screener sectors', err);
      })
      .finally(() => {
        setIsLoaded(true);
      });
  }, [token]);

  return { sectors, isLoaded };
};

export default useScreenerSectors;
